// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Adult_wrapper__3Qhxy","text":"Adult_text__BLirL"};